import Api from '@/api/api.js'

export default {
    /**
     * Liste des fournisseurs
     */
    getStocks() {
        const promise = Api().get("/stocks");
        return promise.then((response) => response.data);
    },

    saveStock(data) {
        const promise = Api().post("/stock", data);
        return promise.then((response) => response.data);
    },

    getStock(id) {
        const promise = Api().get("/stock/" + id);
        return promise.then((response) => response.data);
    },

    addArticle(id, data) {
        const promise = Api().put("/addarticle/" + id, data);
        return promise.then((response) => response.data);
    },

    editStock(id, data) {
        const promise = Api().put("/updatestock/" + id, data);
        return promise.then((response) => response.data);
    },

    deleteStock(id) {
        const promise = Api().delete("/stock/" + id);
        return promise.then((response) => response.data);
    },

    deleteArticle(id, data) {
        const promise = Api().get("/stock/article/" + id, data);
        return promise.then((response) => response.data);
    },

    /**
     * Route pour destocker une entre
     */

    saveDestockage(data) {
        const promise = Api().post("/destockages/store", data);
        return promise.then((response) => response.data);
    },

    /**
     * Liste des stocks entre
     */

    stockage() {
        const promise = Api().get("/stockages");
        return promise.then((response) => response.data);
    },

    getListeArticleEnAttenteRetour(data) {
        const promise = Api().post("/ventes/article-a-retourner", data);
        return promise.then((response) => response.data);
    },

    saveConfirmationRetourStock(data) {
        const promise = Api().post("/ventes/confirmer-retour-stock", data);
        return promise.then((response) => response.data);
    },
};